/* 樹種モーダル（Issue#107）
   - trigger(.ksm__trigger)クリック→モーダル。hrefは本物(SEO)、JSはpreventDefaultして開く。
   - copy.json / cases.json を1回だけfetch（キャッシュ）。ダイニング=スライド／他=文言のみ。
   - 屋久杉等はcopy.imagesの手動画像。画像はモーダルを開いた時だけsrc設定（遅延読込）。 */
(function(){
  "use strict";
  var cacheCopy=null, cacheCases=null, building=null;

  function fetchData(root){
    if(building) return building;
    building = Promise.all([
      cacheCopy ? Promise.resolve(cacheCopy) : fetch(root.dataset.copy).then(function(r){return r.json();}),
      cacheCases ? Promise.resolve(cacheCases) : fetch(root.dataset.cases).then(function(r){return r.json();}).catch(function(){return {};})
    ]).then(function(a){ cacheCopy=a[0]; cacheCases=a[1]; return a; });
    return building;
  }

  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  // 商品ハンドルを種にした決定的シャッフル（商品ごとに順番が変わり、同じ商品では毎回同じ）
  function seededShuffle(arr, seed){
    var a=arr.slice(); if(a.length<2) return a;
    var h=2166136261; seed=String(seed||'');
    for(var i=0;i<seed.length;i++){ h^=seed.charCodeAt(i); h=(h*16777619)>>>0; }
    for(var j=a.length-1;j>0;j--){
      h=(h*1103515245+12345)>>>0; var k=h%(j+1);
      var t=a[j]; a[j]=a[k]; a[k]=t;
    }
    return a;
  }

  function buildModal(root, copy, cases){
    var sp=root.dataset.species,
        dining=root.dataset.dining==='true',
        cta=root.dataset.cta||'',
        c=(copy&&copy[sp])||(copy&&copy._default)||{},
        pts=c.points||[];
    // 画像の決定：ダイニングの時だけ表示。手動images(屋久杉)優先→事例。非ダイニングは文言のみ。
    var imgs=[];
    if(dining){
      // 事例プール（手動指定[屋久杉] or 使用許可事例）から、商品ごとにランダムで最大3枚を選ぶ
      var pool=(c.images&&c.images.length) ? c.images : ((cases&&cases[sp])||[]);
      imgs=seededShuffle(pool, root.dataset.handle).slice(0,3);
    }

    var slider='';
    if(imgs.length){
      var slides=imgs.map(function(im){ return '<img data-src="'+esc(im.url)+'" alt="'+esc(im.cap)+'">'; }).join('');
      var dots=imgs.map(function(_,k){ return '<i'+(k===0?' class="is-on"':'')+'></i>'; }).join('');
      slider='<div class="ksm-slider"><div class="ksm-track">'+slides+'</div>'
           +'<div class="ksm-scrim"></div><div class="ksm-cap">'+esc(imgs[0].cap)+'</div>'
           +'<div class="ksm-dots">'+dots+'</div></div>';
    }
    var facts=pts.map(function(p){
      return '<li><p class="ksm-lead">'+esc(p[0])+'</p><p class="ksm-body">'+esc(p[1])+'</p></li>'; }).join('');
    var full = cta ? '<a class="ksm-full" href="'+esc(cta)+'">'+esc(sp)+'について、さらに詳しく <span>&rarr;</span></a>' : '';

    var wrap=document.createElement('div');
    wrap.innerHTML=
      '<div class="ksm-ovl"></div>'+
      '<div class="ksm-modal" role="dialog" aria-modal="true" aria-label="'+esc(sp)+'について">'+
        '<button class="ksm-close" type="button" aria-label="閉じる">&times;</button>'+
        slider+
        '<div class="ksm-inner'+(imgs.length?'':' no-slide')+'">'+
          '<div class="ksm-kicker">'+esc(c.kicker||'')+'</div>'+
          '<h2 class="ksm-h">'+esc(c.headline||'')+'</h2>'+
          '<ul class="ksm-facts">'+facts+'</ul>'+ full +
          '<p class="ksm-note">二つとない木目。この一枚は、世界にひとつです。</p>'+
        '</div>'+
      '</div>';
    return wrap;
  }

  function attach(root){
    var trigger=root.querySelector('.ksm__trigger');
    if(!trigger) return;
    var built=false, ovl, modal, track, cap, dots, si=0, timer=null, slideCount=0;

    function loadImgs(){ if(!modal) return;
      modal.querySelectorAll('.ksm-track img[data-src]').forEach(function(im){
        im.src=im.getAttribute('data-src'); im.removeAttribute('data-src'); }); }
    function go(n){ if(slideCount<2) return; si=(n+slideCount)%slideCount;
      track.style.transform='translateX(-'+(si*100)+'%)';
      var imgs=modal.querySelectorAll('.ksm-track img'); if(cap&&imgs[si]) cap.textContent=imgs[si].getAttribute('alt');
      dots.forEach(function(d,k){ d.classList.toggle('is-on',k===si); }); }
    function play(){ if(slideCount<2) return; stop(); timer=setInterval(function(){ go(si+1); },4000); }
    function stop(){ if(timer){ clearInterval(timer); timer=null; } }
    function close(){ if(ovl)ovl.classList.remove('is-on'); if(modal)modal.classList.remove('is-on');
      document.body.style.overflow=''; stop(); }

    function open(e){ if(e)e.preventDefault();
      if(!built){
        fetchData(root).then(function(a){
          var frag=buildModal(root,a[0],a[1]);
          ovl=frag.querySelector('.ksm-ovl'); modal=frag.querySelector('.ksm-modal');
          document.body.appendChild(ovl); document.body.appendChild(modal);
          track=modal.querySelector('.ksm-track'); cap=modal.querySelector('.ksm-cap');
          dots=Array.prototype.slice.call(modal.querySelectorAll('.ksm-dots i'));
          slideCount=modal.querySelectorAll('.ksm-track img').length;
          modal.querySelector('.ksm-close').addEventListener('click',close);
          ovl.addEventListener('click',close);
          dots.forEach(function(d,k){ d.addEventListener('click',function(ev){ ev.stopPropagation(); stop(); go(k); play(); }); });
          // タップ／スワイプで手動送り（複数枚のときだけ）
          var slider=modal.querySelector('.ksm-slider');
          if(slider && slideCount>1){
            slider.classList.add('ksm-slider--nav');
            var sx=null, sy=null, swiped=false;
            slider.addEventListener('touchstart',function(e){ var t=e.touches[0]; sx=t.clientX; sy=t.clientY; swiped=false; },{passive:true});
            slider.addEventListener('touchmove',function(e){ var t=e.touches[0]; if(sx!=null && Math.abs(t.clientX-sx)>10) swiped=true; },{passive:true});
            slider.addEventListener('touchend',function(e){
              if(sx==null) return; var t=e.changedTouches[0], dx=t.clientX-sx, dy=t.clientY-sy;
              if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)){ swiped=true; stop(); go(dx<0?si+1:si-1); play(); }
              sx=null;
            },{passive:true});
            slider.addEventListener('click',function(){ if(swiped){ swiped=false; return; } stop(); go(si+1); play(); });
          }
          built=true; show();
        });
      } else { show(); }
    }
    function show(){ loadImgs(); si=0;
      if(track){ track.style.transform='translateX(0)'; }
      if(dots){ dots.forEach(function(d,k){ d.classList.toggle('is-on',k===0); }); }
      ovl.classList.add('is-on'); modal.classList.add('is-on');
      document.body.style.overflow='hidden'; play();
      try{ if(window.gtag) gtag('event','species_modal_open',{species:root.dataset.species,item_id:root.dataset.handle}); }catch(_){}
    }
    trigger.addEventListener('click',open);
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
  }

  function boot(){ document.querySelectorAll('.ksm').forEach(attach); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();
})();
